import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "leave-the-waitlist"
}
const _hoisted_2 = {
  key: 0,
  class: "description"
}
const _hoisted_3 = { class: "check" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 1,
  class: "leave-the-waitlist"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!$setup.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!$setup.showError)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _cache[1] || (_cache[1] = _createElementVNode("h2", null, "Leave the waitlist", -1)),
              (!$setup.isUnsubscribed)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _cache[0] || (_cache[0] = _createTextVNode(_toDisplayString("Your email is\n"), -1)),
                    _createElementVNode("span", null, _toDisplayString(decodeURIComponent($setup.email).toLowerCase()), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_3, _toDisplayString(!$setup.isUnsubscribed ? $setup.textDescription.unsubscribe : $setup.textDescription.unsubscribed), 1),
              (!$setup.isUnsubscribed)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "button",
                    onClick: $setup.unsubscribe
                  }, "Unsubscribe"))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createElementBlock("h2", _hoisted_4, "Something went wrong"))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[2] || (_cache[2] = [
        _createElementVNode("div", { class: "spinner" }, null, -1)
      ]))]))
}